import get from 'lodash/get';
import { object, shape } from 'prop-types';
import React from 'react';

import { withDocumentTitle } from '../generic/DocumentTitle';
import add from '../REST/add';
import api from '../REST/api';
import { tapFlashSuccess, tapFlashWarningMessages } from '../utils/flash';
import storedUserInfo from '../utils/session-data/user-info';
import { campaignObjectives, campaignTypes } from './constants';
import OpportunityForm from './OpportunityForm';
import { transformForRendering } from './transform-opportunity-helpers';
import addOpportunityFollowedByAgreement from './utils/add-opportunity-followed-by-agreements';

const AddOpportunityForm = add({
  update: async (props, changedModel) => {
    const { merchants } = props;
    const checkWarnings = async data => ({
      response: await api.getOpportunitiesValidCombinations({
        id: data.id,
        data: changedModel,
        skipError: true,
      }),
      id: data.id,
    });

    return addOpportunityFollowedByAgreement(changedModel, merchants)
      .then(transformForRendering)
      .then(tapFlashSuccess('Created Opportunity'))
      .then(checkWarnings)
      .then(warnings =>
        tapFlashWarningMessages({ ...warnings.response, id: warnings.id }),
      );
  },
  form: props => <OpportunityForm newModel {...props} />,
  redirectTo: '/opportunities/:id/show',
});

const AddOpportunity = props => {
  const { brandIds } = get(props, 'location.state', {});
  const currentUser = storedUserInfo.get();

  const defaultValues = {
    number: '',
    name: '',
    stage: 'Pitched',
    brandIds,
    merchantIds: [],
    campaignObjective: campaignObjectives.PERFORMANCE,
    campaignType: campaignTypes.OTHER,
    billingType: 'External',
    salesChannel: 'Managed',
    salesUnit: currentUser.salesUnit,
    salesTeam: currentUser.salesTeam,
    negotiatedBy: 'ZMS',
    created: '',
    lastModified: '',
    createdBy: '',
    lastModifiedBy: '',
    ownerId: currentUser.id,
    expectedRevenueMediaManaged: 0,
    expectedRevenueMediaSelfService: 0,
    expectedRevenueCreative: 0,
    expectedRevenueCI: 0,
    expectedRevenueOther: 0,
    agreementOpportunities: [],
    collaboratorIds: [],
    hasCFCampaignLevelSteering: true,
    ...props.location.state,
  };

  return <AddOpportunityForm {...props} default={defaultValues} />;
};

AddOpportunity.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: shape({ state: object }).isRequired,
};

export default withDocumentTitle('Create Opportunity')(AddOpportunity);
